module.exports = __webpack_public_path__ + "img/content.f1108cfc.svg";